export const EXPIRED_MAGIC_LINK = "expired-magic-link" as const
export const INVALID_MAGIC_LINK = "invalid-magic-link" as const

export class MagicLinkError extends Error {
  constructor(message: string) {
    super(message)
  }
}
